<template>
  <div class="main-auth">

    <main>
      <header>
        <h3>应用授权</h3>
        <!-- <span>/ computer management</span> -->
        <div class="btn-group">
          <a-button v-if="$IA('system:app:save')" type="primary" icon="plus" @click="handleOpen('添加')">添加</a-button>
        </div>
      </header>
      <!-- 表格搜索栏 -->
      <div class="toolbar">
        <a-form-model :model="pagination" ref="searchBar" :layout="formLayout">
          <a-form-model-item prop="searchText">
            <a-input-search placeholder="应用" style="width: 200px;" allow-clear :loading="btnLoad"
                            v-model.trim="pagination.searchText" @input="searchTextChange" />
          </a-form-model-item>
          <a-form-model-item prop="orgId">
            <a-select v-model="pagination.orgId" placeholder="部门" style="width: 180px;" allowClear
                      :loading="btnLoad" @change="searchChange"   show-search  :filter-option="filterOption">
              <a-select-option  v-for="item in orgList" :value="item.id">{{item.name}}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item >
            <a-button  @click="resetSearch('表格')">重 置</a-button>
          </a-form-model-item>
        </a-form-model>

      </div>
      <!-- 数据表格 -->

        <a-table :columns="tableColumns" bordered  :data-source="tableData" :pagination="queryCondition" :loading="btnLoad"
                 @change="handleTableChange" :scroll="{ y:570 }"  rowKey="id">


        <span slot="num" slot-scope="text, record, index">
          {{  (Page.current - 1) * Page.pageSize + parseInt(index) + 1  }}
        </span>
        <template slot="appKeyId" slot-scope="text, record">
          <i class="table-copy" @click="copy('#appKeyId' + text)"></i>
          <span :title="text"> {{ text }}</span>
          <input
            style="position: absolute; z-index: -9;"
            :id="'appKeyId' + text"
            :value="text"
          /> 
        </template>
        <template slot="appSecret" slot-scope="text, record">
          <i class="table-copy" @click="copy('#appSecret' + text)"></i>

          <span :title="text"> {{ text }}</span>
          <input
            style="position: absolute; z-index: -9;"
            :id="'appSecret' + text"
            :value="text"
          />
        </template>
        <template slot="enable" slot-scope="text, record">
          <a-switch  @change="onChange($event,record)" :checked="text == 1 ? true : false "  />
        </template>
        <span slot="action" slot-scope="text, record" class="table-action-box">
            <a-tooltip  content="" v-if="$IA('system:app:update')" title="修改" placement="top" effect="light">
              <i class="table-edit" @click="handleOpen('修改', record)" ></i>
            </a-tooltip>
            <a-tooltip  content="" v-if="$IA('system:app:delete')" title="删除" placement="top" effect="light">
              <i class="table-delected" @click="handleOpen('删除', record)" ></i>
            </a-tooltip>
            <a-tooltip  content=""  title="授权" placement="top" effect="light">
              <i class="table-authorizations" @click="empowerOpen('授权', record)" ></i>
            </a-tooltip>
        </span>
      </a-table>
    </main>


    <!-- 添加 -->
    <a-modal
      centered
      :title="modalTitle + '应用'"
      :visible="modalVisible"
      :confirm-loading="btnLoad"
      :confirmLoading="submitLoad"
      @ok="handleOk('authForm')"
      :width="modalTitle == '删除' ? '420px' : '450px'"
      :maskClosable="false"
      @cancel="resetForm"
    >
      <a-form-model v-if="['添加', '修改'].includes(modalTitle)" :model="authForm" ref="authForm"  :rules="authFormRules">
        <a-form-model-item  prop="id" v-show="false">
             <a-input v-model="authForm.id" placeholder="请输入" />
        </a-form-model-item>
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-model-item label="应用"  prop="appName">
              <a-input v-model="authForm.appName" placeholder="请输入" />
            </a-form-model-item>
          </a-col>

          <a-col :span="24">
            <a-form-model-item label="部门" prop="orgId">
              <a-select v-model="authForm.orgId" placeholder="请选择" show-search  :filter-option="filterOption">
                <a-select-option v-for="v in orgList" :key="v.id" :value="v.id">
                  {{ v.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :span="24">
            <a-form-model-item label="是否开启回调地址" prop="appUrlState">
              <a-switch 
               default-checked 
               v-model="authForm.appUrlState"/>
            </a-form-model-item>
          </a-col>
          
          <a-col :span="24" >
            <a-form-model-item label="回调地址" prop="appUrl"  :rules="[
              { required: authForm.appUrlState, max: 250, message: 'Webhook URL最长不能超过250字符且不能为空',trigger: 'blur'  },
              { pattern: /http(s)?\:\/\/.*/, message: 'URL格式不对', trigger: 'blur', },
              ]">
              <a-input v-model="authForm.appUrl" placeholder="请输入" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <template slot="footer">
          <a-button key="back" @click="modalVisible = false"> 取消 </a-button>
          <a-button key="submit" :loading="loading" type="primary" @click="handleOk">
            提交
          </a-button>
        </template>
      </a-form-model>


      <div class="deleteBox" v-if="modalTitle == '删除'">
        <a-icon type="exclamation-circle" theme="filled" />
        <p>此操作将永久删除该应用,是否继续?</p>
      </div>
    </a-modal>

     <!-- 授权 -->
     <a-modal
      centered
      :itle="modalUserTitle"
      :visible="empowerVisible"
      :confirm-loading="btnLoad"
      :confirmLoading="submitLoad"
      width="800px"
      :footer="null"
      @cancel="empowerReset"
      :maskClosable="false"
    >
    <a-spin :spinning="submitLoad" style="padding-bottom: 20px;">
        <a-tabs  :activeKey="activeKey"   @change="callback">
          <a-tab-pane key="1" tab="用户授权">
            <div class="trreSelect" style="padding: 0px;">
              <div class="header">
                <a-form-model :model="userPagination" ref="userPagination" :layout="formLayout" style="display: flex;justify-content: space-between;" >
                 <div>
                   <a-form-model-item prop="searchText">
                     <a-input-search     placeholder="用户名称" allow-clear :loading="btnLoad"
                                         v-model="userPagination.searchText" @input="searchTextChange($event,'授权')" />
                   </a-form-model-item>
                   <a-form-model-item prop="orgId" style=" position: absolute; top: 70px;">
                     <a-select v-model="userPagination.orgId" placeholder="部门" style="width: 180px;" allowClear
                               :loading="btnLoad" @change="searchUserChange">
                       <a-select-option  v-for="item in orgList" :value="item.id">{{item.name}}</a-select-option>
                     </a-select>
                   </a-form-model-item>
                 </div>
                  <a-form-model-item style="margin-right: 0px;">
                  <a-button  icon="redo" @click="resetSearch('授权')" size="small" >重  置</a-button>
                </a-form-model-item>
                </a-form-model>
              </div>
              <br />
              <a-table
                :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, onSelect:handleSelectionChange,onSelectAll:handAllUserChange}"
                :columns="userTableColumns"
                :data-source="resourcesData"
                :pagination="userQueryCondition"
                @change="handleUserTableChange"
                rowKey="id"
                :loading="userTableLoad"
                bordered
              >
              <template slot="userKey" slot-scope="text, record">
                <span :title="text"> {{ text }}</span>
                  <a-icon type="copy" v-if="text" @click="copy('#userKey' + text)" style="color: #007acc;margin-left:5px"/>
                <input
                  v-if="text"
                  style="position: absolute; z-index: -9;right: -215px;"
                  :id="'userKey' + text"
                  :value="text"
                /> 
               </template>
              </a-table>
            </div>
          </a-tab-pane>
          <a-tab-pane key="2" tab="事件授权">
          <div class="trreSelect treeBox" >
            <a-tree
              v-if="this.eventCheckedData && this.eventCheckedData.length > 0"
              v-model="checkedKeys"
              checkable
              checkStrictly
              :replace-fields="replaceFields"
              :tree-data="eventCheckedData"
              :expandedKeys.sync="expandedKeys"
              @check="treeCheck"
            />
            </div>
          </a-tab-pane>
        
        </a-tabs>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>


import {notification} from "ant-design-vue";

export default {
  data() {
    return {
      btnLoad: false,
      tableLoad: false,
      loading:false,
      submitLoad:false,
      pagination: {
        searchText: "",
        content: "",
        params: "",
        orgId:undefined,
        pageSize: 10,
        pageNo: 1,
        total: 0,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showTotal: (total, range) => `显示 ${range[0]} 到 ${range[1]} ，共 ${total} 条记录  `
      },
      formLayout:"inline",
      queryCondition:{},
      tableColumns: [
        {
          title: "序号",
          dataIndex: "index",
          key: "index",
          align: "center",
          width: 65,
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: "应用",
          dataIndex: "appName",
          key: "appName",
          ellipsis: true
        },
        {
          title: '部门',
          dataIndex: 'orgName',
          key: 'orgName',
          ellipsis: true,
        },
        {
          title: "应用Key",
          dataIndex: "appKeyId",
          key: "appKeyId",
          scopedSlots: { customRender: "appKeyId" },
          ellipsis: true
        },
        {
          title: "应用密钥",
          dataIndex: "appSecret",
          key: "appSecret",
          scopedSlots: { customRender: "appSecret" },
          ellipsis: true
        },
        {
          title: "回调地址",
          dataIndex: "appUrl",
          key: "appUrl",
          ellipsis: true
        },
        {
          title: '状态',
          key: 'enable',
          dataIndex: 'enable',
          scopedSlots: { customRender: "enable" },
          ellipsis: true
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          width: 120,
          scopedSlots: { customRender: "action" },
        },
      ],
      tableData: [],
      authForm:{
        id:"",
        appName:"",
        appUrl:'',
        appUrlState:true,
        orgId:undefined,
      },
      // 模态框显隐
      modalVisible: false,
      // 模态框标题  
      modalTitle: "",
      // 添加/修改保存API
      saveApi: "",
      // 单行数据
      singleDta: "",
      // 分页参数
      pagCurrent:{},
      authFormRules: {
        appName:[{ required: true, max: 20, message: "应用名称最长不能超过20字符且不可为空" }],
        orgId: [{ required: true, message: '部门不能为空' }],
        // appUrl: [
        //   { required: true, max: 250, message: "Webhook URL最长不能超过250字符且不能为空",trigger: "blur"  },
        //   { pattern: /http(s)?\:\/\/.*/, message: "URL格式不对", trigger: 'blur', },
        // ],
      },
      // 授权
      empowerVisible:false,
      // 分配资源
      activeKey:'1',
      treeApi:"",
      grantApi:"",
      // 流程半选状态
      checkedList: [],
      indeterminate: false,
      checkAll: false,
      // 单条数据
      distributionData:{
        appId:""
      },
      resourcesData: [],
      // 部门
      orgList:[],

      //  用户授权表头
      userTableColumns: [
        {
          title: "序号",
          dataIndex: "index",
          key: "index",
          align: "center",
          width: 65,
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: "昵称",
          dataIndex: "name",
          key: "name",
          ellipsis: true,
          width:160
        },
        {
          title: "UserKey",
          dataIndex: "userKey",
          key: "userKey",
          ellipsis: true,
          scopedSlots: { customRender: "userKey" },
          width:400
        },
        {
          title: '部门',
          dataIndex: 'orgName',
          key: 'orgName',
          ellipsis: true,
        },
      ],
      
      // 用户授权表格搜索数据
      userPagination:{
        searchText:"",
        content: "",
        params: "",
        orgId:undefined,
        pageSize: 5,
        pageNo: 1,
        total: 0,
        appId:'',
        showQuickJumper: true,
        showSizeChanger: true,
        defaultCurren:3,
        pageSizeOptions: ['5', '10', '20', '30', '40', '50'],
        showTotal: (total, range) => `共 ${total} 条记录  `
      },

      // 分页参数
      pagUserCurrent:{},

      // 用户授权数据请求
      userQueryCondition:{},
 
      // 用户授权提交
      valueSaveData:[],

      // 用户表格加载
      userTableLoad: false,
      
      // 用户授权名称
      modalUserTitle:"",
      
      // 用户授权表格已授权选中
      selectedRowKeys: [], 

      // 事件授权
      replaceFields: {
        children: 'children',
        title: 'name',
        key:'value'
      },
      expandedKeys:[],
      // 事件列表
      eventCheckedData:[],
      // 事件授权提交字段
      replaceForm:{
        appId:"",
        eventKeys:[]
      },
      // 选中
      checkedKeys: [],
    };
  },
  methods: {
    // 搜索
    filterOption(input, option) {
      return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    // 部门
    allorgList(){
      this.axios
          .post("/org/findParentOrg",)
          .then((res) => {
            if (res.code === 200) {
              this.orgList = res.data
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 用户授权单选
    handleSelectionChange(record, selected){
        var saveData = {
          chosen: selected,
          appId: this.distributionData.appId,
          userIds:record.id
        };
      this.grantUserSubmi(saveData)
    },

    // 用户授权多选
    handAllUserChange(selected, selectedRows, changeRows){
      let obj = [];
      changeRows.forEach((element) => {
        obj.push(element.id);
      });
       var saveData = {
          chosen: selected,
          appId: this.distributionData.appId,
          userIds:obj
        };
        saveData.userIds = saveData.userIds.join(',')
      this.grantUserSubmi(saveData)
    },
     
    // 监听用户授权表格赋值
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    
    // 用户授权表格提交通用方法
    grantUserSubmi(data){
      this.axios
          .post(this.grantApi,data)
          .then((res) => {
            this.submitLoad = false;
            if (res.code === 200) {
              notification.success({
                message: res.message,
                duration: 3,
                customClass: "batch-import",
              })
              this.handleUserTableChange(this.userQueryCondition)
            }
          })
          .catch((err) => {
            this.submitLoad = false;
            console.log(err);
          });
    },

    // 重置表单通用方法
    resetForm() {
      if ( this.modalTitle =='添加' || this.modalTitle =='修改' ) {
          this.$refs.authForm.resetFields()
      }
      this.modalVisible = false
    },

    // 重置搜索
    resetSearch(title){
      switch (title) {
        case '表格':
          this.$refs.searchBar.resetFields()
          this.pagination.current  = 1
          this.searchChange()
          break
        case '授权':
          this.$refs.userPagination.resetFields()
          this.searchUserChange()
          break
      }

    },

    // 打开模态框
    handleOpen(title,data) {
      this.modalTitle = title;
      this.modalVisible = true;
      this.$nextTick(()=>{
        this.singleDta = data
        switch (title) {
          case '添加':
            this.saveApi = '/app/save'
            this.authForm.appUrl = ''
            break;
          case '修改':
            this.saveApi = '/app/update'
            this.authForm = this.$lodash.pick(
              this.singleDta,
              this.$lodash.keys(this.authForm)
            );
            switch (this.authForm.appUrlState) {
              case 1:
                this.authForm.appUrlState = true
                break;
              case 0:
                this.authForm.appUrlState = false
                break;
            }
            break;
          case '删除':
            
            break;
        }
      })
    },

    // 确认模态框
    handleOk(formName) {
      if (this.modalTitle == "添加" || this.modalTitle == "修改") {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submitLoad = true;
            let saveData = "";
            saveData = this.$lodash.cloneDeep(this.authForm);
            switch (saveData.appUrlState) {
              case true:
              saveData.appUrlState = 1
                break;
              case false:
              saveData.appUrlState = 0
              saveData.appUrl = ''
                break;
            }
            this.axios
              .post(this.saveApi, saveData)
              .then((res) => {
                this.submitLoad = false;
                if (res.code === 200) {
                  notification.success({
                    message: res.message,
                    duration: 3,
                    customClass: "batch-import",
                  })
                  this.handleTableChange(this.modalTitle == "添加"? this.pagination:this.pagCurrent);
                  this.resetForm()
                }
              })
              .catch((err) => {
                this.submitLoad = false;
                console.log(err);
              });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      } else {
          this.submitLoad = true;
          this.axios
            .delete("/app/delete/" + this.singleDta.id)
            .then((res) => {
              this.submitLoad = false;
              if (res.code === 200) {
                notification.success({
                  message: res.message,
                  duration: 3,
                  customClass: "batch-import",
                })
                this.handleTableChange(this.pagCurrent);
                this.modalVisible = false;
              }
            })
            .catch((err) => {
              this.submitLoad = false;
              console.log(err);
            });
      }
    },

    // 打开授权框
    empowerOpen(title,data){
      this.empowerVisible = true
      this.distributionData.appId = data.id
      this.replaceForm.appId = data.id
      this.modalUserTitle = title
      this.activeKey = '1';
      this.callback('1')
      this.$refs.userPagination.resetFields()
    },
    
    // 授权框取消
    empowerReset(){
      this.empowerVisible = false
      this.checkAll = true
      this.expandedKeys = []
      this.userPagination.current = 1
      this.$refs.userPagination.resetFields()
      this.searchUserChange()
    },

    // 监听tab切换
    callback(val){
      this.activeKey = val
      this.resourcesData = []
      this.checkedKeys = []
      this.userPagination.current = 1
      switch (val) {
        case '1':
          this.searchUserChange()
          this.grantApi = 'app/userGrant'
          break;
       case '2':
          this.grantApi = '/app/eventGrant'
          this.axios
          .post('/app/eventTreeList',this.$qs.stringify(this.distributionData))
          .then((res) => {
            if (res.code === 200) {
                 this.eventCheckedData = res.data.allEvent
                 this.checkedKeys = res.data.checkedEventKeys
            }
          })
          .catch((err) => {
            console.log(err);
          });
          break;
      }
    },
    
    // 用户授权搜索
    searchUserChange(v) {
      this.userPagination.appId =  this.distributionData.appId
      this.userQueryCondition = this.$lodash.cloneDeep(this.userPagination)
      this.userTableAjax()
    },

    // 监听用户授权翻页
    handleUserTableChange(pagination, filters, sorter) {
      this.userQueryCondition.pageNo =  pagination.current ? pagination.current : 1
      this.userQueryCondition.current =  pagination.current ? pagination.current : 1
      this.userQueryCondition.pageSize = pagination.pageSize ? pagination.pageSize : 10
      this.pagUserCurrent = pagination ? pagination : this.userPagination
      this.userTableAjax()
    },

    // 翻页请求
    userTableAjax() {
      this.userTableLoad = true;
      this.axios
        .post("/appUser/findList", this.$qs.stringify(this.userQueryCondition))
        .then((res) => {
          this.userTableLoad = false;
          if (res.code === 200) {
            this.resourcesData = res.data.allAppUser.records;
            this.userQueryCondition.total = res.data.allAppUser.total;

            // 表格复选框时,要配置表格key
            this.selectedRowKeys =  res.data.checkedAppUserIds
          }
        })
        .catch((err) => {
          console.log(err);
          this.userTableLoad = false;
        });
    },
   // 表格 活动监听字段更新
   onChange(checked,record) {
     if (checked) {
      this.switchChange(record,'/app/enable')
     }else{
      this.switchChange(record,'/app/disable')
     }
    },
    switchChange(data,api){
      this.axios
        .post(api,{id:data.id,appName:data.appName})
        .then((res) => {
          if (res.code == 200) {
            this.handleTableChange(this.pagCurrent);
            notification.success({
              message: res.message,
              duration: 3,
              customClass: "batch-import",
            })
          } 
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 复制
    copy(domId) {
      document.querySelector(domId).select();
      try {
        if (window.clipboardData) {
          //清空操作系统粘贴板
          window.clipboardData.clearData();
          //将需要复制的内容复制到操作系统粘贴板
          window.clipboardData.setData("Text", document.querySelector(domId).value);
        } else {
          document.execCommand("copy");
        }
        this.$message.success("复制成功！请粘贴（Ctrl+V）使用");
      } catch (error) {
        console.log(error);
        this.$message.error("复制失败！请更换浏览器（Edge/Chrome）再次尝试");
      }
    },

    // 复选框选中监听
    treeCheck(checkedIds, {checked, checkedNodes, node, event}){
      // 存在子节点时
      if (node.$children.length>0) {
        if (checked===true) {
          this.$confirm({
            title: '请您选择勾选类型！',
            content: '您想 [全选] '+node.title+'及其所有子级权限？还是仅 [单选] '+node.title+'权限？',
            okText: '全选',
            cancelText: '单选',
            onOk:() => {
              console.log('全选');
              let tempChildIds = node.dataRef.children.map(x=>{return x.value})
              this.checkedKeys = this.$lodash.difference(this.checkedKeys.checked,tempChildIds).concat(tempChildIds)
              this.replaceForm.eventKeys = this.checkedKeys
              this.resourcesSubmit()
            },
            onCancel:() => {
              console.log('单选');
              this.replaceForm.eventKeys = checkedIds.checked
              this.resourcesSubmit()
            },
          });
        }
        if (checked===false) {
          this.$confirm({
            title: '请您选择取消勾选类型！',
            content: '您想 [取消全选] '+node.title+'及其所有子级权限？还是仅 [取消单选] '+node.title+'权限？',
            okText: '取消全选',
            cancelText: '取消单选',
            onOk:() => {
              console.log('取消全选');
              node.dataRef.children.forEach(x=>{
                if (this.checkedKeys.checked.indexOf(x.value)!==-1) {
                  this.checkedKeys.checked.splice(this.checkedKeys.checked.indexOf(x.value),1)
                }
              })
              this.replaceForm.eventKeys = this.checkedKeys.checked
              this.resourcesSubmit()
            },
            onCancel:() => {
              console.log('取消单选');
              this.replaceForm.eventKeys = checkedIds.checked
              this.resourcesSubmit()
            },
          });
        }
      } else {
        this.replaceForm.eventKeys = checkedIds.checked
        this.resourcesSubmit()
      }
    },

    // 事件授权提交
    resourcesSubmit() {
      this.submitLoad = true;
      this.replaceForm.eventKeys = this.replaceForm.eventKeys.join(",")
      this.axios
        .post('/app/eventGrant', this.replaceForm)
        .then((res) => {
          this.submitLoad = false;
          notification.success({
            message: res.message,
            duration: 3,
            customClass: "batch-import",
          })
        })
        .catch((err) => {
          this.submitLoad = false;
        });
    },

    // 监听搜索输入框输入
    searchTextChange(val,title) {
      if (window.searchTimer) {
        clearTimeout(searchTimer);
      }
      window.searchTimer = setTimeout(() => {
       if (title == '授权') {
        this.searchUserChange(val)
       }else{
        this.searchChange(val)
       }
       
      }, 1200);
    },

    // 搜索
    searchChange(v) {
      this.queryCondition = this.$lodash.cloneDeep(this.pagination)
      this.tableAjax()
    },

    // 监听翻页
    handleTableChange(pagination, filters, sorter) {
      this.queryCondition.pageNo =  pagination.current ? pagination.current : 1
      this.queryCondition.current =  pagination.current ? pagination.current : 1
      this.queryCondition.pageSize = pagination.pageSize ? pagination.pageSize : 10
      this.pagCurrent = pagination ? pagination : this.pagination
      this.tableAjax()
    },

    // 翻页请求
    tableAjax() {
      this.tableLoad = true;
      this.axios
        .post("/app/findPage", this.$qs.stringify(this.queryCondition))
        .then((res) => {
          this.tableLoad = false;
          if (res.code === 200) {
            this.tableData = res.data.records;
            this.queryCondition.total = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
          this.tableLoad = false;
        });
    },
  },
  beforeMount() {
    this.allorgList()
    this.searchChange()
  }
};
</script>

<style lang="scss" scoped>
.main-auth {


  main {
    margin: 16px;
    background-color: #fff;
    border-radius: 2px;

    header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid #f0f0f0;

      h3 {
        margin-bottom: 0;
        height: 18px;
        line-height:17px;
        padding-left: 12px;
        border-left: 4px solid #3373F2;
        font-size: 16px;
        font-weight: bold;
        color: #3d4966;
      }

      span {
        line-height: 16px;
        margin-left: 10px;
        color: #808080;
      }
    }


    .toolbar {
      display: flex;
      justify-content: space-between;
      padding: 16px;

      .search-bar {
        flex: 1;
      }
      .ant-form{
        .ant-form-item{
          margin-right: 16px;
        }
        .ant-form-item:last-child{
          .ant-btn{
            width: 74px;
            position: absolute;
          }
        }
      }
    }
    .ant-table-wrapper{
      padding: 0 16px 16px;
    }

    .ant-tag {
      border-radius: 16px;
    }
  }
}
  // 分配资源样式
  ::v-deep .ant-modal-content{
    .ant-modal-header{
      // border-bottom: 1px solid #e8e8e8;
    }
    .ant-modal-body{
      .ant-tabs-bar{
        border-bottom: none;
      }
    }
    .trreSelect{
   
      // overflow: auto;
      //border: 1px #ccc solid;
      border-radius: 4px;
      padding: 0px 10px 10px;
      .header{
        // width: 567px;
        // margin-left: -9px;
        //padding: 10px 0;
        padding-top: 10px;
        height:48px;
        //border-bottom: 1px #d7dde4 solid;

        .ant-checkbox-wrapper{
          margin: 0px 20px 10px 10px;
        }
        .ant-input{
          width: 165px;
        }
        .ant-select-selection{
          width: 165px;
          .ant-select-selection__rendered{
            width: 165px;
          }
        }


      }
      .content{
        margin: -10px 0px 0 0;
        max-height: 380px;
        overflow: auto;
        .ant-checkbox-group{
          .ant-checkbox-wrapper{
            width: 100%;
            margin: 5px 0;
          }
        }
      }
      //.ant-table-pagination.ant-pagination{
      //      margin-right: 15px;
      //}
    }
    .treeBox{
      max-height: 380px;
      overflow: auto;
      border: 1px #ccc solid;
      }
  }
</style>
